import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface NumberSettingFieldProps {
  label: string;
  description?: string;
  value: number;
  onChange: (value: number) => void;
  min?: number;
}

/**
 * Labeled numeric setting input with an optional helper description, used for
 * threshold fields (days, hours, dollar floors) in the template settings forms.
 */
export function NumberSettingField({
  label,
  description,
  value,
  onChange,
  min = 0,
}: NumberSettingFieldProps) {
  return (
    <div className="space-y-1.5">
      <Label className="text-sm">{label}</Label>
      {description && (
        <p className="text-xs text-muted-foreground">{description}</p>
      )}
      <Input
        type="number"
        className="w-[140px]"
        min={min}
        value={value}
        onChange={(e) => {
          const parsed = Number(e.target.value);
          if (Number.isFinite(parsed)) {
            onChange(parsed);
          }
        }}
      />
    </div>
  );
}
